/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputSessionDivision
 */
export interface OutputSessionDivision {
    /**
     * 
     * @type {number}
     * @memberof OutputSessionDivision
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputSessionDivision
     */
    name: string;
}

/**
 * Check if a given object implements the OutputSessionDivision interface.
 */
export function instanceOfOutputSessionDivision(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputSessionDivisionFromJSON(json: any): OutputSessionDivision {
    return OutputSessionDivisionFromJSONTyped(json, false);
}

export function OutputSessionDivisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSessionDivision {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputSessionDivisionToJSON(value?: OutputSessionDivision | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

